import React from "react";
import ReactApexCharts from "react-apexcharts";

const AreaChart = ({ codeList }) => {
  // Data for the area chart
  const chartData = codeList;
  const formattedDates = chartData?.map((dateString) => {
    const date = new Date(dateString?.created_day);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    });
  });
  const series = [
    {
      name: "Clicks",
      data: chartData.map((item) => item.clicks),
    },
  ];

  const options = {
    chart: {
      type: "area",
      stacked: false,
      toolbar: {
        show: false,
      },
      background: "#030504",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "smooth",
      lineCap: "round",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 0.1,
        stops: [0, 100],
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0,
        stops: [0, 90, 100],
        colorStops: [
          {
            offset: 0,
            color: "#4bb390",
            opacity: 0.7,
          },
          {
            offset: 90,
            color: "rgba(75, 179, 144, 0.10)",
            opacity: 0.4,
          },
          {
            offset: 100,
            color: "rgba(75, 179, 144, 0.10)",
            opacity: 0.5,
          },
        ],
      },
    },
    colors: ["#4bb390"],
    grid: {
      show: false, // Remove grid lines
    },
    xaxis: {
      categories: formattedDates,
      axisBorder: {
        show: true,
        color: "var(--Text-Light, rgb(176 176 176 / 30%))",
      },
      labels: {
        style: {
          colors: "var(--Text-Light, #B0B0B0)", // Change label color
          textAlign: "right", // Align labels to right
          fontFamily: "Manrope",
          fontSize: "14px",
          fontWeight: 400,
        },
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      labels: {
        formatter: function (val) {
          return val;
        },
        style: {
          colors: "var(--Text-Light, #B0B0B0)", // Change label color
        },
      },
    },
    tooltip: {
      theme: "dark", // Use dark theme for tooltip
      x: {
        format: "MMM",
      },
      style: {
        background: "#1e1e1e", // Customize tooltip background color
        fontSize: "14px",
      },
    },
  };

  return (
    <div>
      <ReactApexCharts
        options={options}
        series={series}
        type="area"
        height={"274px"}
      />
    </div>
  );
};

export default AreaChart;
